const validate = {
  rules: {
    ano: {
      required: true,
    },
    descricao: {
      required: true,
    },
    titulo: {
      required: true,
    },
  },
  messages: {
    ano: "O ano é obrigatório.",
    descricao: "A descrição é obrigatória.",
    titulo: "O título é obrigatório.",
  },
};

export default validate;
